import { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from "@windmill/react-ui";
import { toNumberTag } from '../../utils/number';

import toast, { Toaster } from "react-hot-toast";

import { useAccount, useNetwork, useWalletClient, useSwitchNetwork, useSendTransaction, useBalance } from 'wagmi'
import { parseEther } from 'viem'
import { getChainId } from '../../utils/connectors';
import { ethers, utils, BigNumber } from 'ethers'
import { useDispatch, useSelector } from '../../store';
import useApi from '../../hooks/useApi';
import { ChangePage } from '../../store/reducers/menu';
import { UpdateInfo } from '../../store/reducers/auth';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ethereum = 'ether';

const DepositMetamask = forwardRef(({ modalStyle, functions }, ref) => {
    const Api = useApi();
    const history = useHistory();
    const dispatch = useDispatch();
    const { user, currency, ethAdminAddress } = useSelector((state) => state.auth);
    const { address, isConnecting, isConnected, isDisconnected, connector } = useAccount();
    const { switchNetwork } = useSwitchNetwork()
    const { chain, chains } = useNetwork();
    const [adminAddress, setAdminAddress] = useState("");
    const { data: walletClient } = useWalletClient({ chainId: chain?.id })
    const { sendTransaction } = useSendTransaction({
        onSuccess(data) {
            if (data.hash) {
                const amounti = utils.parseUnits(amount.toString(), 18);
                depositMetamask(data.hash, amounti);
            }
        }
    })

    const { data: ethBalance, refetch, isLoading } = useBalance({
        address,
        chainId: chain?.id
    })

    useEffect(() => {
        if (isLoading === false) {
            getBalance();
        }
    }, [isLoading])

    const [balance, setBalance] = useState(0);
    const [loading, setLoading] = useState(false);
    const [amount, setAmount] = useState('');

    const handleClick = async () => {
        const chainId = getChainId(currency.network)
        if (chain?.id !== chainId) {
            switchNetwork?.(
                chainId
            )
        }

    };

    const depositMetamask = (txn_id, amounti) => {
        Api.depositMetamask({
            amounti: amounti.toString(),
            from: address,
            address: currency.contractAddress,
            txn_id
        })
            .then(({ data }) => {
                setLoading(false);
                toast.success("Deposit is successfully.");
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const getContract = useMemo(() => {
        if (walletClient && walletClient.chain) {
            const address = currency.contractAddress;
            const network = {
                chainId: walletClient.chain.id,
                name: walletClient.chain.name,
                ensAddress: walletClient.chain.contracts?.ensRegistry?.address,
            }
            const provider = new ethers.providers.Web3Provider(walletClient.transport, network)
            const signer = provider.getSigner(walletClient.account.address)
            const contractInstance = new ethers.Contract(address, currency.abi, signer)
            return contractInstance;
        }
    }, [walletClient, currency])

    const onDepositMetamask = async () => {
        if (amount === '' || Number(amount) === 0) {
            toast.error('You do not have enough amount.');
        } else if (Number(amount) < Number(currency.minDeposit)) {
            toast.error(`Minimum Deposit is ${currency.minDeposit}${currency.symbol}.`);
        } else if (balance < Number(amount)) {
            toast.error('Balances not enough.');
        } else {
            if (currency.contractAddress === ethereum) {
                try {
                    setLoading(true);
                    sendTransaction({
                        to: adminAddress,
                        value: parseEther(`${amount}`)
                    })
                } catch (e) {
                    setLoading(false);
                }

            } else {
                try {
                    try {
                        setLoading(true);
                        const contract = getContract;
                        if (contract) {
                            const decimals = await contract.decimals();
                            const amounti = utils.parseUnits(amount.toString(), decimals);

                            const data = await contract.transfer(adminAddress, amounti);
                            if (data.hash) {
                                depositMetamask(data.hash, amounti);
                            }
                        }
                    } catch (e) {
                        console.log(e)
                        setLoading(false);
                    }
                } catch (e) {
                    console.log(e, "error")
                }
            }
        }
    };

    const getBalance = useCallback(async () => {
        if (address !== user?.cryptoAccount) {
            Api.updateUserInfo({ cryptoAccount: address, update: false }).then(({ data }) => {
                dispatch(UpdateInfo(data));
            });
        }
        if (address && currency.abi && walletClient) {
            try {
                if (currency.contractAddress === ethereum) {
                    if (ethBalance && ethBalance.formatted) {
                        setBalance(Number(ethBalance.formatted))
                    }
                } else {
                    const contract = getContract;
                    if (contract) {
                        const decimals = await contract.decimals();
                        const balance = await contract.balanceOf(address);
                        const amount = utils.formatUnits(balance, decimals);
                        setBalance(Number(amount))
                    }

                    // const add: `0x${string}` = currency.contractAddress as `0x${string}`;

                    // const balance = await fetchBalance({
                    //     address: address,
                    //     token: add
                    // })
                    // console.log(balance, "bal")
                    // if (balance.formatted) {
                    //     setBalance(Number(balance.formatted))
                    // }
                }
            } catch (error) {
                console.log(error, "error");
            }
        }
    }, [walletClient, ethBalance]);

    useEffect(() => {
        if (address && walletClient) {
            getBalance();
        }
        // eslint-disable-next-line
    }, [address, currency, walletClient]);

    useEffect(() => {
        if (user?.cryptoAccount) handleClick();
        // eslint-disable-next-line
    }, [user]);

    useEffect(() => {
        Api.getAdminAddress().then(({ data }) => {
            setAdminAddress(data);
        })
    }, [])

    return (
        <div id="metamask-modal"
            tabIndex={-1}
            style={{ backgroundColor: "rgba(22,22,22,0.8)" }}
            aria-hidden="true"
            className="flex justify-center items-center fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-screen"
            data-modal-backdropclasses="bg-yellow-700">
            <div className="relative rounded-lg shadow w-full max-w-xl dark:bg-black">
                <button
                    type="button"
                    className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                    data-modal-hide="login-modal"
                    onClick={() => {
                        dispatch(ChangePage(""))
                    }}
                >
                    <svg
                        className="w-3 h-3"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 14"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                        />
                    </svg>
                    <span className="sr-only">Close modal</span>
                </button>
                <div className="px-6 py-6 lg:px-8">
                    <h1 className="text-white">{`Deposit ${currency.name}`}</h1>
                    <div className="flex flex-col mt-4">
                        <p className="text-sm text-white mt-2"> {toNumberTag(balance)} {currency.symbol} Available</p>
                    </div>
                    <input
                        type="number"
                        placeholder="500"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-primary dark:border-gray-500 dark:placeholder-gray-400 dark:text-white mt-4"
                        required=""
                        label={'Deposit amount'}
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                    <div className="flex flex-col mt-4">
                        <p className="text-sm text-white mt-2"> Minimum Deposit: {currency.minDeposit} {currency.symbol}</p>
                    </div>
                    <div className="flex flex-col mt-4">
                        <Button
                            disabled={loading || amount === '' || Number(amount) === 0}
                            onClick={onDepositMetamask} layout="primary">
                            Deposit
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default DepositMetamask;
